import type { World } from '../ecs/world'
import { hurtPlayer } from './damage'

/**
 * THE defining mechanic: health drains continuously, independent of damage.
 * Standing still still kills you. Food is life. Drain scales gently with
 * depth so late floors stay tense. All rates in config.
 */
export function attritionSystem(world: World, dt: number): void {
  const cfg = world.tuning.attrition
  const rate = cfg.hpPerSecond * (1 + cfg.depthScale * Math.max(0, world.floor - 1))
  for (const p of world.players()) {
    if (p.hp === undefined || p.dead) continue
    p.hp -= rate * dt
    if (p.hp <= 0) {
      p.hp = 1
      p.invuln = 0
      hurtPlayer(world, p, 1, 'nutrient non-compliance')
      continue
    }
    const ps = p.player!
    ps.starvingEventT -= dt
    if (p.hp <= cfg.starvingThreshold && ps.starvingEventT <= 0) {
      ps.starvingEventT = world.tuning.daise.starvingRepeatEvery
      world.bus.emit('player_starving', { hp: p.hp })
    }
  }
}
